/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { OnInit, OnDestroy, Component, Output, EventEmitter } from "@angular/core";

declare var $: any;

@Component({
  selector: 'app-sites-footer-component',
  templateUrl: './sites-footer.component.html',
  styleUrls: ['./sites-footer.component.css']
})
export class SitesFooterComponent implements OnInit {
  
  @Output()
  setScaleClicked = new EventEmitter<void>();
  
  @Output()
  uploadMapClicked = new EventEmitter<void>();
  
  @Output()
  addZoneClicked = new EventEmitter<void>();
  
  @Output()
  addSubLocationClicked = new EventEmitter<void>();
  
  @Output()
  toggleTrackingClicked = new EventEmitter<void>();
  
  ngOnInit(): void {
    //Enable the Tool tips
    $("#sitesFooter").tooltip({ selector: '[data-toggle=tooltip]' });
  }
  
}
